
const DirecitveEntryDiagnosticEntryCanceled = () => {
  return (
    <p className="text-danger-soft">
      Proposta declinada
    </p>
  );
}

export default DirecitveEntryDiagnosticEntryCanceled;
